import { type inferParserType, parseAsStringLiteral, useQueryState } from 'nuqs'

export type BookingStep = inferParserType<typeof parser>

export const BOOKING_STEPS = [
	'start',
	'daySelect',
	'timeSelect',
	'multiDaysSelect',
] as const

const parser = parseAsStringLiteral(BOOKING_STEPS).withDefault('start')

export const useBookingActiveStep = () => {
	return useQueryState('step', parser)
}
